import { render, staticRenderFns } from "./OrderExchangeConfirm.vue?vue&type=template&id=ce70388e&scoped=true"
import script from "./OrderExchangeConfirm.vue?vue&type=script&lang=js"
export * from "./OrderExchangeConfirm.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeConfirm.vue?vue&type=style&index=0&id=ce70388e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce70388e",
  null
  
)

export default component.exports